import { SVGProps } from 'react'

type ArrowIconProps = SVGProps<SVGSVGElement>

const ArrowIcon = ({ className, ...props }: ArrowIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={22}
    fill="none"
    className={className}
    {...props}
  >
    <path
      fill="#fff"
      d="M24.53 13.1H9.733l4.15 3.947a2.456 2.456 0 0 1 .086 3.475 2.46 2.46 0 0 1-3.477.086L.012 10.642 10.493.678a2.46 2.46 0 0 1 3.477.087c.937.983.898 2.54-.086 3.474l-4.15 3.947h14.795c1.359 0 2.502 1.1 2.502 2.457 0 1.358-1.143 2.458-2.502 2.458Z"
    />
  </svg>
)

export default ArrowIcon
